<template>
  <ul
    v-if="showUsps"
    class="product-usps"
  >
    <li
      v-if="!isDigital && $variable('settings.freeShippingThreshold') > 0"
      class="product-usps__item text-body-xs-regular"
    >
      <icon-van aria-hidden="true" />

      <span
        v-text="$string(
          'product.free_shipping',
          { replace: { amount: $formatMoney($variable('settings.freeShippingThreshold')) } },
        )"
      />
    </li>

    <li
      v-for="(value, index) of uspsMetafield"
      :key="`usp-${product.id}-${index}`"
      class="product-usps__item text-body-xs-regular"
    >
      <component
        :is="getIcon(value.icon)"
        aria-hidden="true"
      />

      <span v-html="value.text" />
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Product usps (product-usps)
 * -----------------------------------------------------------------------------
 * Variant and/or product level USPs with icon and text.
 *
 * @param {Boolean|Object} product - Product.
 * @param {Boolean|Object} variant - Selected variant.
 *
 */
import IconCalendar from '~icons/general/calendar.svg'
import IconKey from '~icons/general/key.svg'
import IconMagGlass from '~icons/general/magglass.svg'
import IconManual from '~icons/general/manual.svg'
import IconPhone from '~icons/general/phone.svg'
import IconPlay from '~icons/general/play.svg'
import IconSpanner from '~icons/general/spanner.svg'
import IconTick from '~icons/general/tick.svg'
import IconVan from '~icons/general/van.svg'

import { isDigitalVariant } from '~/helpers/product'

export default {
  name: 'ProductUsps',

  components: {
    IconCalendar,
    IconKey,
    IconMagGlass,
    IconManual,
    IconPhone,
    IconPlay,
    IconSpanner,
    IconTick,
    IconVan,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
  },

  data() {
    return {
      productTypes: {
        bundle: this.$variable('settings.productOptions.bundle'),
        digital: this.$variable('settings.productOptions.digital'),
        physical: this.$variable('settings.productOptions.physical'),
      },
    }
  },

  computed: {

    /**
     * Compute if the selected variant is a digital product.
     * @returns {Boolean}
     */
    isDigital() {
      return isDigitalVariant(this.variant)
    },

    /**
     * Compute if USPs should render.
     * @returns {Boolean}
     */
    showUsps() {
      return this.uspsMetafield?.length > 0 || !this.isDigital
    },

    /**
     * Compute variant-level or product-level USP data.
     * @returns {Array}
     */
    uspsMetafield() {
      if (!this.variant) {
        return this.product.metafields?.usps
      }

      return this.variant.metafields.usps
        ? this.variant.metafields.usps
        : this.product.metafields?.usps
    },
  },

  methods: {

    /**
     * Return name of icon component.
     * @param {String} icon - Icon name.
     * @returns {String}
     */
    getIcon(icon) {
      return `Icon${icon}`
    },
  },
}
</script>

<style lang="scss">
@import './product-usps';
</style>
